import Select from "react-select";
import { Search } from "lucide-react";
import "../css/GeneralCss.css";
import { useTheme } from "@emotion/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const SearchComponent = ({ items, onSearch, placeholder }) => {
  const muiTheme = useTheme(); 
  const [filter, setFilter]=useState(items[0].value);
  const { t } = useTranslation();
  
  const onChange = (e)=>{
    setFilter(e.value);
    }

  const customStyles = {
    control: (base) => ({
      ...base,
      border: "none",
      boxShadow: "none",
      cursor: "default",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? muiTheme.palette.primary.main
        : state.isFocused
        ? muiTheme.palette.primary.main + "20"
        : "#fff",
      color: state.isSelected ? "#fff" : "#000",
    }),
  };
  return (
    <div className="d-flex w-100 mb-3 gap-2">
      <div style={{ width: "16.3%" }}>
        <Select
          options={items}
          // placeholder={t("search.selectFilter")}
          isSearchable={false}
          className="py-custom"
          styles={customStyles}
          onChange={onChange}
          defaultValue={items[0]}
        />
      </div>

      <div className="position-relative flex-grow-1 d-flex align-items-center">
        <div className="position-absolute top-50 start-0 translate-middle-y ps-3 text-secondary">
          <Search size={18} />
        </div>
        <input
          type="text"
          className="form-control ps-5 py-custom"
          placeholder={t(`search.${placeholder}`)}
          style={{
            backgroundColor: "#FCFAFA",
            borderColor: "transparent",
          }}
          onChange={(e)=>onSearch(e.target.value, filter)}
        />
      </div>
    </div>
  );
};
